import axios from 'axios';
import store from '@/store/index';

export function urlBuilder(path, params = null) {
  const apiUrl = process.env.VUE_APP_BACKEND_URL;
  let url = `${apiUrl}${path}`;
  if (params) {
    url += '?';
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(params)) {
      if (url.slice(-1) !== '?') url += '&';
      url += `${key}=${value}`;
    }
  }
  return `${url}`;
}

export async function refresh() {
  let response = {};

  try {
    response = await axios.post(urlBuilder('/token/refresh/'), { refresh: store.getters.refreshToken });
  } catch (error) {
    store.commit('deleteAccessToken');
    store.commit('deleteRefreshToken');
    return error.response.status;
  }
  if (response.status === 200) {
    store.commit('saveAccessToken', response.data.access);
  }
  return response.status;
}
